import { NgModule, ModuleWithProviders } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { WephoneUtilsModule } from '@wephone-utils';
import { SmsinHandlerComponent, SmsSentComponent, SentSmsModalComponent, ConversationDetailComponent } from './component';
import { SmsService, SmsDialogService } from './service';
import { WephoneCommonModule } from '@wephone-common';
import { WephoneSmsRoutingModule } from './wephone-sms.routing.module';
import { SmsSetScheduleComponent } from './component/sms-set-schedule/sms-set-schedule.component';
import { SmsScheduledComponent } from './component/sms-scheduled/sms-scheduled.component';


@NgModule({
  imports: [
    WephoneUtilsModule,
    TranslateModule,
    WephoneCommonModule,
    WephoneSmsRoutingModule
  ],
  exports: [
    SmsinHandlerComponent,
    SmsSentComponent,
    SentSmsModalComponent,
    SmsSetScheduleComponent,
    ConversationDetailComponent,
    SmsScheduledComponent
  ],
  declarations: [
    SmsinHandlerComponent,
    SmsSentComponent,
    SentSmsModalComponent,
    ConversationDetailComponent,
    SmsSetScheduleComponent,
    SmsScheduledComponent
  ],
  entryComponents: [
    ConversationDetailComponent,
    SentSmsModalComponent,
    SmsSetScheduleComponent,
    SmsScheduledComponent
  ]
})
export class WephoneSMSModule {

  static forRoot(): ModuleWithProviders<WephoneSMSModule> {
    return {
      ngModule: WephoneSMSModule,
      providers: [
        SmsService,
        SmsDialogService
      ],
    };
  }
}
